/**
 *   Import
 *   - Libraries
 */
 import * as React from 'react'
 import { FormikState } from 'formik'

/**
 *     Import
 *     - Components
 */
 import { Logo } from '../../common/Logo/Logo'
 import { LoginWrapper } from '../Login/components/LoginWrapper/LoginWrapper'

 import RecoverForm from '../../../containers/pages/RecoverForm/RecoverForm'
 import { Values } from '../../../containers/pages/RecoverForm/RecoverForm'

/**
 * Props
 * @type {Object}
 */
 export type Props = {
     error: any;
     match: any;
     recoverpassword: any;
     userError: any;
     recoverSuccess: any;
 }

 export const Recover: React.SFC<Props & FormikState<Values>> = (props) => {
     return (
         <LoginWrapper>
         <Logo />
         <RecoverForm {...props} />
         </LoginWrapper>
         )
 }



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Recover/Recover.tsx